<script setup lang="ts">
/**
 * Tooltip texte standard de The H'O — coquille fine sur <el-tooltip> qui FIGE
 * les défauts (effet sombre, placement haut, délai 200ms) pour garantir une UX
 * homogène. Remplace à la fois les `title="..."` natifs et les `el-tooltip`
 * dispersés dans le front.
 *
 * Usage simple (texte) :
 *   <AppTooltip content="Vue 3D du système">
 *     <el-button>...</el-button>
 *   </AppTooltip>
 *
 * Usage contenu structuré : passer le slot #content (préférer <AppInfoCard>
 * pour les vraies cartes riches avec image/sections).
 *
 * Toute prop el-tooltip non listée (hide-after, offset, trigger…) est
 * transmise telle quelle via les attributs de repli.
 */
import type { Placement } from 'element-plus';

withDefaults(
  defineProps<{
    /** Texte du tooltip (ignoré si le slot #content est fourni). */
    content?: string;
    placement?: Placement;
    /** Délai avant affichage (ms). 200 = défaut maison. */
    showAfter?: number;
    effect?: 'dark' | 'light';
    disabled?: boolean;
    /** Autoriser le HTML brut dans `content`. À éviter (préférer #content). */
    rawContent?: boolean;
    /** Classe additionnelle sur le popper. */
    popperClass?: string;
  }>(),
  {
    content: undefined,
    placement: 'top',
    showAfter: 200,
    effect: 'dark',
    disabled: false,
    rawContent: false,
    popperClass: undefined,
  },
);

defineOptions({ inheritAttrs: false });
</script>

<template>
  <el-tooltip
    :content="content"
    :placement="placement"
    :show-after="showAfter"
    :effect="effect"
    :disabled="disabled"
    :raw-content="rawContent"
    :popper-class="popperClass"
    v-bind="$attrs"
  >
    <slot />
    <template v-if="$slots.content" #content>
      <slot name="content" />
    </template>
  </el-tooltip>
</template>
